import React from 'react';
import ServicePageTemplate, { ALL_SERVICES } from './ServicePageTemplate';

const pageData = {
  seo: {
    title: 'AI-Powered Technology Solutions | RojrzTech',
    description:
      'RojrzTech delivers cutting-edge AI-powered technology solutions — machine learning, NLP, computer vision, intelligent automation, and AI integration services.',
  },
  hero: {
    badge: 'AI TECHNOLOGY EXPERTS',
    slides: [
      {
        heading: { pre: 'Automate & Innovate', gold: 'with AI' },
        subheading:
          'Say goodbye to the manual grind for good. We offer AI technology services that inject real smarts into your whole system and automate the havoc.',
        pills: ['Machine Learning', 'NLP', 'Computer Vision', 'Automation'],
        image: '/Ai.jpeg',
      },
      {
        heading: { pre: 'Real Intelligence Into', gold: 'Your Business Systems' },
        subheading:
          'We integrate advanced AI capabilities — including large language models, predictive analytics, and intelligent automation — directly into your existing workflows.',
        pills: ['ChatGPT API', 'LLMs', 'Predictive AI', 'RAG', 'AI Agents'],
        image: '/Ai1.jpeg',
      },
      {
        heading: { pre: 'AI Solutions That', gold: 'Work for You' },
        subheading:
          'From intelligent chatbots to computer vision systems, we build AI solutions that solve real business problems and deliver measurable competitive advantages.',
        pills: ['Chatbots', 'Vision AI', 'Data Analysis', 'Integration', 'Custom AI'],
        image: '/Ai.jpeg',
      },
    ],
  },
  servicesCards: {
    title: 'Our Comprehensive AI-Powered Technology Services',
    subtitle:
      'We help businesses harness the power of artificial intelligence to automate processes, uncover insights, and create intelligent digital products.',
    cards: [
      {
        icon: '🤖',
        title: 'AI Chatbot Development',
        description:
          'Intelligent conversational AI chatbots powered by GPT and LLMs that handle customer support, lead qualification, and complex queries 24/7.',
      },
      {
        icon: '🧠',
        title: 'Machine Learning Solutions',
        description:
          'Custom machine learning models that analyze your data, identify patterns, and make intelligent predictions to drive better business decisions.',
      },
      {
        icon: '👁️',
        title: 'Computer Vision Systems',
        description:
          'Advanced image and video recognition systems for quality control, facial recognition, document processing, and visual inspection automation.',
      },
      {
        icon: '📊',
        title: 'AI-Powered Analytics',
        description:
          'Intelligent analytics platforms that transform raw data into actionable insights, forecasts, and automated recommendations for your business.',
      },
      {
        icon: '⚙️',
        title: 'Intelligent Process Automation',
        description:
          'AI-driven automation solutions that eliminate repetitive tasks, reduce errors, and free your team to focus on high-value work.',
      },
      {
        icon: '🔗',
        title: 'AI Integration & APIs',
        description:
          'Seamlessly integrate AI capabilities — OpenAI, Claude, Gemini, and custom models — into your existing applications and business systems.',
      },
    ],
  },
  features: {
    title: 'AI-Powered Technology Services for Accelerated Business Growth',
    subtitle:
      'Leverage cutting-edge artificial intelligence to enhance your capabilities, streamline operations, and gain a competitive edge in your market.',
    items: [
      'Natural Language Processing',
      'Large Language Models',
      'Computer Vision',
      'Predictive Analytics',
      'Process Automation',
      'AI Chatbots',
      'Recommendation Engines',
      'Sentiment Analysis',
      'Document AI',
      'Speech Recognition',
      'AI Model Fine-tuning',
      'Custom AI APIs',
    ],
  },
  excellence: {
    title: 'Collaborative Excellence',
    subtitle:
      "At RojrzTech, we prioritize collaboration to ensure the best AI outcomes for our clients. We work closely with your team to understand your needs and build AI solutions that truly work.",
    cards: [
      {
        icon: '🎯',
        title: 'Precision & Accuracy',
        description:
          'Our AI solutions are rigorously trained and tested to ensure high accuracy, reliability, and performance in real-world conditions.',
      },
      {
        icon: '🔒',
        title: 'Secure & Ethical AI',
        description:
          'We build AI systems with security and ethics at the forefront — protecting your data, your users, and your brand reputation.',
      },
      {
        icon: '⚡',
        title: 'Rapid AI Deployment',
        description:
          'From proof-of-concept to production in record time. Our expert AI team accelerates your time-to-value with proven frameworks.',
      },
      {
        icon: '📈',
        title: 'Measurable Business Impact',
        description:
          'Every AI solution we build is tied to concrete business metrics — cost savings, efficiency gains, or revenue growth you can measure.',
      },
      {
        icon: '🔄',
        title: 'Continuous Learning & Improvement',
        description:
          'Our AI systems continuously learn from new data, improving their performance over time and adapting to changing business needs.',
      },
      {
        icon: '🚀',
        title: 'Scalable AI Architecture',
        description:
          'Built on cloud-native, scalable architectures that handle growing data volumes and increasing demand without performance degradation.',
      },
    ],
  },
  relatedServices: ALL_SERVICES.filter((s) => s.href !== '/services/ai-technologies'),
};

const AiTechnologies = () => <ServicePageTemplate pageData={pageData} />;
export default AiTechnologies;
